// @ts-nocheck

export const localeCodes =  []
export const localeLoaders = {}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/0829bad8" /* webpackChunkName: "config_i18n_46config_46js_0829bad8" */)
]
export const normalizedLocales = []

